const menubar = [
  "file",
  "edit",
  "view",
  "insert",
  "format",
  "tools",
  "table",
  "help"
].join(" ");

export default menubar;
